import { Link } from "react-router-dom"
import Button from "./Button"
import "./index.scss"

const PostRequest = () => {
    return (
        <>
            <div className="post-request-list">
                <div className="d-flex align-items-center flex-wrap justify-content-between">
                    <div className="d-flex align-items-center flex-wrap">
                        <span>
                            <img src="https://www.pngitem.com/pimgs/m/581-5813504_avatar-dummy-png-transparent-png.png" alt="" />
                        </span>
                        <h6 className="m-0 ms-3">Vivek Mishra<br />
                            <small>Requested on: <span className="text-muted">12 May 2033</span></small>
                        </h6>
                    </div>
                </div>
                <hr />

                <div className="d-flex flex-wrap align-items-center justify-content-between">
                    <div className="d-flex flex-fill">
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                    </div>
                    <Link className="text-decoration-none">Budget:<span className="mx-2"><small><i className="fa fa-rupee"></i></small>500 - <small><i className="fa fa-rupee"></i></small>550</span></Link>
                </div>
            </div>
                <div className="footer-request">
                    <div className="row">
                        <div className="col-lg-5 p-0">
                            <p className=""><span className="text-muted">Interested Vendors:</span><br /><b>272</b></p>
                        </div>
                        <div className="col-lg-7 text-end">
                            <Button title="View Request" />
                        </div>
                    </div>
                </div>
        </>
    )
}

export default PostRequest